<template>
    <divBox class="trajectory-left">
        <div>更新时间：2021-09-28 14:0</div>
        <div style="height: 300px" class="chart-box">
            sdfsf
        </div>
        <div style="height: 300px" class="chart-box">
            sdfsf
        </div>
        <div style="height: 300px" class="chart-box">
            sdfsf
        </div>
    </divBox>
</template>

<script>
import divBox from '../../components/divBox.vue'
export default {
    components: {
        divBox
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss" scoped>
.trajectory-left {
    padding: 12px;
    color: #fff;
    font-size: 20px;
    .chart-box {
        background: rgba(0,0,0,0.45);
        border-radius: 3px;
        margin-top: 12px;
    }
}
</style>